export var RatingStyles = function RatingStyles(props) {
  var disabled = props.disabled,
      readOnly = props.readOnly,
      theme = props.theme;
  var palette = theme.palette;
  return {
    root: [!disabled && !readOnly && {
      selectors: {
        // This is part 1 of highlighting all stars up to the one the user is hovering over
        '&:hover': {
          selectors: {
            '.ms-RatingStar-back': {
              color: palette.neutralPrimary
            }
          }
        }
      }
    }],
    ratingStarFront: {
      color: palette.neutralPrimary
    }
  };
};